export { default } from './BancoDoAuto25BannerAgo26';
